<template>
  <div class="create">
    <!-- card -->
    <el-card class="box-card">
      <!-- card header -->
      <div slot="header" class="clearfix">
        <span>文档创建</span>
        <el-button
          class="tz-r tz-create-btn"
          type="primary"
          round
          @click="jump('/document')"
          >返回</el-button
        >
      </div>
      <!-- card header -->

      <!-- card content -->
      <el-form
        :model="formData"
        :rules="rules"
        label-width="110px"
        ref="formData"
      >
        <el-form-item label="序号" prop="docSort">
          <el-input v-model="formData.docSort"></el-input>
        </el-form-item>
        <el-form-item label="标准类型" prop="remark">
          <el-input v-model="formData.remark"></el-input>
        </el-form-item>

        <el-form-item label="上传附件">
          <!-- <MyEditor ref="editor" /> -->
          <el-upload
            class="upload-demo"
            action=""
            :on-preview="handlePreview"
            :on-change="handleChange"
            :on-remove="handleRemove"
            :http-request="uploadFn"
            :on-exceed="handleExceed"
            :limit="1"
            :file-list="fileList"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>

        <!-- <el-form-item label="文件地址" prop="url">
          <el-input
            v-model="formData.url"
            placeholder="上传附件自动回填"
            disabled
          ></el-input>
        </el-form-item> -->
        <el-form-item label="发布编号" prop="number">
          <el-input v-model="formData.number"></el-input>
        </el-form-item>
        <el-form-item label="中文名字" prop="name">
          <el-input v-model="formData.name"></el-input>
        </el-form-item>
        <el-form-item label="英文名字" prop="enName">
          <el-input v-model="formData.enName"></el-input>
        </el-form-item>
        <el-form-item label="发布时间" prop="pubtime">
          <el-date-picker
            v-model="formData.pubtime"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="请选择发布时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="实施时间" prop="usetime">
          <el-date-picker
            v-model="formData.usetime"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="请选择实施时间"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="发布机构 " prop="agency">
          <el-input v-model="formData.agency"></el-input>
        </el-form-item>

        <div
          class="button-group"
          style="display: flex; justify-content: center"
        >
          <el-button
            type="primary"
            style="width: 185px; margin: 0 20px"
            class="form-button"
            @click="submitFn"
          >
            <span>创建</span>
          </el-button>
          <el-button
            style="width: 185px; margin: 0 20px"
            class="form-button"
            @click="clearFn"
          >
            <!-- <i v-if="item.icon" :class="item.icon"></i> -->
            <span>重置</span>
          </el-button>
        </div>
      </el-form>

      <!-- card content -->
    </el-card>
    <!-- card -->
  </div>
</template>

<script>
import { addDoc } from '@/api/document'
import { uploadFile } from '@/api/training'
// import MyEditor from './components/MyEditor.vue'
export default {
  // components: { MyEditor },
  data() {
    return {
      fileList: [], //上传文件列表
      // 表单配置
      formData: {
        // id: '',
        url: '',
        remark: '',
        docSort: '',
        usetime: '',
        agency: '',
        pubtime: '',
        number: '',
        enName: '',
        name: ''
        // value: ''
      },
      rules: {
        docSort: [{ required: true, message: '序号必填', trigger: 'blur' }],
        remark: [{ required: true, message: '标准类型必填', trigger: 'blur' }],
        name: [{ required: true, message: '中文名字必填', trigger: 'blur' }],
        pubtime: [{ required: true, message: '发布时间必填', trigger: 'blur' }],
        usetime: [{ required: true, message: '实施时间必填', trigger: 'blur' }],
        number: [{ required: true, message: '发布编号必填', trigger: 'blur' }],
        agency: [{ required: true, message: '发布机构必填', trigger: 'blur' }]
      },
      formBtns: [
        {
          content: '创建',
          width: '185px',
          type: 'primary'
        },
        {
          content: '重置',
          width: '185px',
          type: ''
        }
      ]
    }
  },
  created() {
    // this.queryEquipmentFn()
  },
  methods: {
    // 判断富文本编辑器输入是否为空或回车
    getText(str) {
      return str
        .replace(/<[^<p>]+>/g, '') // 将所有<p>标签 replace ''
        .replace(/<[</p>$]+>/g, '') // 将所有</p>标签 replace ''
        .replace(/&nbsp;/gi, '') // 将所有 空格 replace ''
        .replace(/<[^<br/>]+>/g, '') // 将所有 换行符 replace ''
    },
    isNull(str) {
      if (str == '') return true
      var regu = '^[ ]+$'
      var re = new RegExp(regu)
      return re.test(str)
    },
    // 上传附件
    uploadFn(parma) {
      console.log(parma.file)
      const formData = new FormData()
      formData.append('multipartFile', parma.file) // 传入bpmn文件
      this.$loading({
        text: '文件上传中'
      })
      uploadFile(formData).then((res) => {
        console.log(res.data, '创建')
        if (res.code == 200) {
          // this.formData.fileSize = res.data.fileSize
          // this.formData.uploadName = res.data.uploadName
          // this.formData.uploadType = res.data.uploadType
          this.formData.url = res.data.uploadUrl
          console.log(this.formData)
          this.$message({
            message: '上传成功',
            type: 'success'
          })
        } else {
          this.fileList = []
          this.$message({
            message: '上传失败',
            type: 'success'
          })
        }
      })
      this.$loading().close()
    },
    // 下载文件
    handlePreview(file) {
      console.log(file)
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(file.raw, file.name)
      } else {
        var link = document.createElement('a')
        link.download = file.name
        link.href = window.URL.createObjectURL(file.raw)
        link.click()
        window.URL.revokeObjectURL(link.href)
      }
    },
    //移除文件
    handleRemove() {
      this.fileList = []
      this.$message({
        message: '移除成功',
        type: 'success'
      })
      // this.formData.fileSize = ''
      // this.formData.uploadName = ''
      // this.formData.uploadType = ''
      this.formData.url = ''
    },
    //超限制
    handleExceed(files, fileList) {
      console.log(files, fileList)

      this.$message.warning('目前只能上传一个包')
    },
    handleChange(file) {
      console.log(file)
      //获取上传文件大小
      // let imgSize = Number(file.size / 1024 / 1024)
      // if (imgSize > 50) {
      //   this.$msgbox({
      //     title: '',
      //     message: '文件大小不能超过500MB，请重新上传。',
      //     type: 'warning'
      //   })
      //   this.fileList = []
      //   return
      // }
    },
    submitFn() {
      console.log(this.formData, '文档创建')
      // if (this.formData.url == '') {
      //   this.$message.error('附件不能为空！')
      //   return
      // }
      // this.formData.value = this.$refs.editor.html
      // let text = this.getText(this.formData.value)
      // let validateValue = this.isNull(text)
      // console.log(this.isNull(text)) // true表示判空  false表示不为空
      // if (validateValue) {
      //   this.$message({
      //     message: '内容不能为空',
      //     type: 'error'
      //   })
      //   return
      // }
      this.$refs.formData.validate((isSuccess) => {
        if (isSuccess) {
          if (this.submited) return
          this.$loading({
            text: '文档添加中'
          })
          let infos = this.formData

          let addparams = {
            ...infos
          }
          let addArr = []
          addArr.push(addparams)
          console.log(addArr, '文档创建')
          addDoc(addArr).then((res) => {
            console.log(res.data, '创建')
            if (res.code == 200) {
              this.submited = true
              this.$message({
                message: '添加成功',
                type: 'success'
              })
              // this.$router.go(-1)
              setTimeout(() => {
                this.$router.push('/document')
              }, 500)
            } else {
              this.$message({
                message: res.data,
                type: 'error'
              })
            }
          })
          this.$loading().close()
        }
      })
    },
    // 重置
    clearFn() {
      this.fileList = []
      this.$refs.formData.resetFields()
    }
  }
}
</script>

<style></style>
